module.exports = __webpack_public_path__ + "img/mozzo1.69dc299c.jpeg";